import React from 'react';
import styles from "./ManualPricingTable.module.scss";
import {isCustom, StripePriceObject} from './stripePriceObject';

export function getCurrencySymbol(currency: 'eur' | 'usd' | string) {
    return (
        <>
            {currency === 'eur' && <span>&euro;&nbsp;</span>}
            {currency === 'usd' && <span>&dollar;&nbsp;</span>}
        </>
    );
}
interface AmountSpanProps {
    decimals?: number;
    className?: string;
    small?: boolean;
    showMonthly?: boolean;
    price: {
        recurring?: StripePriceObject['recurring'];
        unit_amount: StripePriceObject['unit_amount'];
        currency?: StripePriceObject['currency'];
    },
    freeSpan?: boolean;
}

export default function AmountSpan({ price: selectedPrice, showMonthly, decimals = 2, small, className = '', freeSpan = true }: AmountSpanProps) {
    if (isCustom(selectedPrice) || typeof selectedPrice.unit_amount === 'string') {
        return <b>Custom solutions</b>
    }
    const amount = selectedPrice.unit_amount / 100 / (showMonthly && selectedPrice.recurring?.interval === 'year' ? 12 : 1);
    return amount === 0 && freeSpan ? <span className={`${styles.Price}`}>Free</span>
        : (
        <span className={`${styles.Price} ${small ? styles.Small : ''} ${className}`}>
            <AmountSpan.Amount currency={selectedPrice.currency} amount={amount} decimals={decimals} />
        </span>
    );
}

AmountSpan.Amount = function Amount({ currency, amount, decimals = 2 }:  Pick<AmountSpanProps, 'decimals'> & { amount: number; currency?: string; decimals?: number }) {
    return (
      <span>
          {currency && getCurrencySymbol(currency)}
          <span>{amount.toFixed(decimals)}</span>
      </span>
    );
}
